import React from 'react'
import Contact from '../Contact'

function WarehouseOffices() {
  return (
    <div>
        <Contact />
    </div>
  )
}

export default WarehouseOffices